module.exports = __webpack_public_path__ + "static/media/facebook.bb33a536.png";